import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// mui
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer } from '@mui/material';
import { IconButton } from '@mui/material';
// components
import Logo from '../organisms/Logo'
// style
import '../style/header.css';

const Header = (props :any) => {
  const [open, setOpen] = useState(false);
 
  const handleDrawerOpen = () => {
    setOpen(true);
  }

  const handleDrawerClose = () => {
    setOpen(false);
  }

  return (
    <header id="app-header">
      <div className='header-wrap'>
        <Link to='/#top'>
          <Logo/>
        </Link>
        <nav className='nav'>
          <Link to='/'><div className='link'>TOP</div></Link>
          <Link to='/#profile'><div className='link'>PROFILE</div></Link>
          <Link to='/#shop'><div className='link'>SHOP</div></Link>
          <Link to='/#gallery'><div className='link'>GALLERY</div></Link>
          <Link to='/#guidelines'><div className='link'>GUIDELINES</div></Link>
          <div className='sns-btn-wrap'>
            <a href="https://x.com/kanami_k73" className="flowbtn my_x1">
              <i className="fa-brands fa-x-twitter"></i>
            </a>
          </div>
          <div className='sns-btn-wrap'>
            <a href="https://www.youtube.com/@kanami-channel" className="flowbtn my_youtube1">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </nav>
        <div className='menu-btn'>
          <MenuIcon onClick={handleDrawerOpen} style={{fontSize: 30, color: '#7dafdf'}}/>
        </div>
        <Drawer anchor="right" open={open} onClose={handleDrawerClose} PaperProps={{ style: { width: '70%' } }} className='drawer'>
          <div className='close-btn'>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon style={{fontSize: 30, color: '#7dafdf'}}/>
            </IconButton>
          </div>
          <div className='list-wrap'>
            <Link to='/#top' onClick={handleDrawerClose}><div className='link'>TOP</div></Link>
            <Link to='/#profile' onClick={handleDrawerClose}><div className='link'>PROFILE</div></Link>
            <Link to='/#shop' onClick={handleDrawerClose}><div className='link'>SHOP</div></Link>
            <Link to='/#gallery' onClick={handleDrawerClose}><div className='link'>GALLERY</div></Link>
            <Link to='/#guidelines' onClick={handleDrawerClose}><div className='link'>GUIDELINES</div></Link>
            <div className='sns-btn-wrap'>
              <a href="https://x.com/kanami_k73" className="flowbtn my_x1">
                <i className="fa-brands fa-x-twitter"></i>
              </a>
            </div>
            <div className='sns-btn-wrap'>
              <a href="https://www.youtube.com/@kanami-channel" className="flowbtn my_youtube1">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </Drawer>
      </div>
    </header>
  );
};

export default Header;